import router from '@/router'
import store from '@/store'

const whiteList = [ 'Login', 'ForgotPassword' ] // 不重定向白名单

router.beforeEach((to, from, next) => {
  if (whiteList.indexOf(to.name) > -1) {
    next()
  } else {
    if (store.getters.isLogin) return next()
    // return next()
    store.dispatch('getUserInfo').then(response => {
      // 拿到一些统计数据
      const { account } = response.data.customer
      store.dispatch('queryUser', {
        query: { query: `uid:${account.userId}` }
      })
      next()
    })
  }
})
